import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { SearchLg, TextInput } from '@opendate-app/setlist';

const DEBOUNCE_MS = 400;

const CalendarSearchInput = ({ value, onChange, shortcutHint }) => {
  const [text, setText] = useState(value || '');

  useEffect(() => { setText(value || ''); }, [value]);

  const notify = useMemo(() => debounce(onChange, DEBOUNCE_MS), [onChange]);
  useEffect(() => () => notify.cancel(), [notify]);

  return (
    <TextInput
      id="calendar-search"
      type="search"
      size="sm"
      placeholder="Search events..."
      aria-label="Search events"
      leadingIcon={SearchLg}
      trailingText={shortcutHint ? <kbd className="calendar-search-kbd">/</kbd> : undefined}
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        notify(e.target.value);
      }}
    />
  );
};

CalendarSearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  shortcutHint: PropTypes.bool,
};

CalendarSearchInput.defaultProps = {
  value: '',
  shortcutHint: true,
};

export default CalendarSearchInput;
